var global = {
  verbose: true,
  debug: false,
  site_path: window.site_path
};
export default global;